import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './SignUpNotificationModal.css';

const SignUpNotificationModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [betaTester, setBetaTester] = useState(false);
  const [devUpdates, setDevUpdates] = useState(false);
  const [mobileDevice, setMobileDevice] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Email validation function
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex
    return regex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return; // Prevent submission if email is invalid
    }

    try {
      // TODO: Replace with your actual API endpoint
      const response = await axios.post('/api/notification', {
        email: email,
        isbetatester: betaTester,
        isdevupdates: devUpdates,
        mobile_device: mobileDevice });

      if (response.status === 200) {
        setSubmitted(true);
        setError('');
        // Reset form after successful submission
        setEmail('');
        setBetaTester(false);
        setDevUpdates(false);
        setMobileDevice(''); // Reset the mobile device state
      } else {
        const message = err.response?.data || 'Something went wrong. Please try again.';
        setError(message);
      }
    } catch (err) {
        const message = err.response?.data || 'Failed to submit. Please try again later.';
        console.log(err);
      setError(message);
    }
  };

  const handleClose = () => {
    setSubmitted(false);
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <button className="close-button" onClick={handleClose}>x</button>
        
        {!submitted ? (
          <>
            <h2>Stay Updated</h2>
            <p>Sign up to be notified when we launch!</p>
            
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                />
              </div>

              <div className="form-group checkbox">
                  <input
                    type="checkbox"
                    id="devUpdates"
                    checked={devUpdates}
                    onChange={(e) => setDevUpdates(e.target.checked)}
                  />
                  <label htmlFor="devUpdates">
                    Receive notifications on application development updates
                  </label>
              </div>

              <div className="form-group checkbox">
                  <input
                    type="checkbox"
                    id="betaTester"
                    checked={betaTester}
                    onChange={(e) => setBetaTester(e.target.checked)}
                  />
                  <label htmlFor="betaTester">
                    I'm interested in being a beta tester
                  </label>
              </div>

              {/* Conditionally render the mobile device section */}
              {betaTester && (
                <div className="form-group">
                  <label>Select which brand of mobile/tablet device you use:</label>
                  <div>
                    <label>
                      <input
                        type="radio"
                        value="Apple"
                        checked={mobileDevice === 'Apple'}
                        onChange={(e) => setMobileDevice(e.target.value)}
                      />
                      Apple
                    </label>
                    <label>
                      <input
                        type="radio"
                        value="Android"
                        checked={mobileDevice === 'Android'}
                        onChange={(e) => setMobileDevice(e.target.value)}
                      />
                      Android
                    </label>
                    <label>
                      <input
                        type="radio"
                        value="Both"
                        checked={mobileDevice === 'Both'}
                        onChange={(e) => setMobileDevice(e.target.value)}
                      />
                      Both
                    </label>
                  </div>
                </div>
              )}

              {error && <div className="error-message">{error}</div>}

              <button type="submit" className="submit-button">
                Sign Up
              </button>
            </form>
          </>
        ) : (
          <div className="success-message">
            <h2>Thank You!</h2>
            <p>We'll notify you when we launch{betaTester ? ' and contact you about beta testing' : ''}{devUpdates ? ' and keep you updated on development progress' : ''}!</p>
            <button onClick={handleClose} className="close-success-button">
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SignUpNotificationModal;
